import { Controller } from "@hotwired/stimulus";

// The list of races, loaded into a Turbo Frame. The two filter checkboxes are
// remembered in sessionStorage and sent along as query parameters.
export default class extends Controller {
  static targets = ["frame", "hidden", "participating"];
  static values = { url: String };

  connect() {
    this.hiddenTarget.checked = sessionStorage.showHiddenEvents == 1;
    this.participatingTarget.checked = sessionStorage.showParticipatingEvents == 1;
    this.load();
  }

  toggleHidden() {
    sessionStorage.setItem("showHiddenEvents", this.hiddenTarget.checked ? 1 : 0);
    this.load();
  }

  toggleParticipating() {
    sessionStorage.setItem("showParticipatingEvents", this.participatingTarget.checked ? 1 : 0);
    this.load();
  }

  load() {
    const url = new URL(this.urlValue, window.location.origin);
    const current = this.frameTarget.querySelector("[data-month]");
    if (current && current.dataset.month) url.searchParams.set("month", current.dataset.month);
    if (this.hiddenTarget.checked) url.searchParams.set("show_hidden", "1");
    if (this.participatingTarget.checked) url.searchParams.set("show_participating", "1");
    const src = url.pathname + url.search;
    if (this.frameTarget.getAttribute("src") === src) {
      this.frameTarget.reload();
    } else {
      this.frameTarget.src = src;
    }
  }
}
